export default __webpack_public_path__ + "static/media/Faraland.222b40b4.png";